module.exports = __webpack_public_path__ + "img/fig24.80de97c6.jpg";